import { render, staticRenderFns } from "./multilang-input.vue?vue&type=template&id=a86bec4e&"
import script from "./multilang-input.vue?vue&type=script&lang=ts&"
export * from "./multilang-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports